import { type ObjectValuesUnionType } from '../../../utils/typing';

export const KLBannerStates = Object.freeze({
  TEASER: 'TEASER',
  START: 'START',
  ELIMINATED: 'ELIMINATED',
  T_RED: 'T_RED',
  T_WHITE: 'T_WHITE',
  ORIENTATION: 'ORIENTATION',
  POLE: 'POLE',
  ENDING: 'ENDING',
  RESUME: 'RESUME',
});

export type KLBannerState = ObjectValuesUnionType<typeof KLBannerStates>;
